import 'angular';
import AppConstants from '../gorillaboy/AppConstants';

interface PurgeVersionService {
    deleteDocumentVersion: Function;
    deletePriorDocumentVersions: Function;
    deleteDocumentVersions: Function;
}

PurgeVersionServiceFactory.$inject = ['$rootScope',
    '$http',
    '$q',
    'EndpointService'];

function PurgeVersionServiceFactory($rootScope, $http, $q, EndpointService) {
    const httpMethods = AppConstants.HttpMethods;
    const SERVICE_ROOT = EndpointService.endpoint(true) + 'documentVersions/';
    const PurgeVersionService: PurgeVersionService = {

        deleteDocumentVersion: (documentId, documentVersion) => {
            var config = {
                url: SERVICE_ROOT + documentId + '/versions/' + documentVersion + '?deletePriorVersions=false',
                method: httpMethods.DELETE
            };
            return $http(EndpointService.tokenize(config));
        },

        deletePriorDocumentVersions: (documentId, documentVersion) => {
             var config = {
                 url: SERVICE_ROOT + documentId + '/versions/' + documentVersion + '?deletePriorVersions=true',
                 method: httpMethods.DELETE
             };
             return $http(EndpointService.tokenize(config));
        },

        deleteDocumentVersions: (documentId, documentVersion, deletePriorVersions) => {
            var config = {
                url: SERVICE_ROOT + documentId + '/versions/' + documentVersion + '?deletePriorVersions=' + deletePriorVersions,
                method: httpMethods.DELETE
            };
            return $http(EndpointService.tokenize(config));
        }
    }
    return PurgeVersionService;
}

angular.module('GorillaBoy.services')
    .factory('PurgeVersionService', PurgeVersionServiceFactory);

export {
    PurgeVersionService
}